import axios from 'axios';
import getToken from '@/helpers/getToken';

export const apiBaseUrl =
  process.env.VUE_APP_API_BASE_URL || 'https://api.siteletsbook.com.br/v2/';

const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    common: {
      Authorization: getToken(),
    },
    Pragma: 'no-cache',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const statusCode = error.response.status;
      const isLoginUrl = window.location.pathname === '/login';
      const errorMessage = error.response.data.roleUpdated
        ? 'Seu nível de permissão mudou, realize o login novamente.'
        : 'Seu acesso expirou, realize o login novamente.';

      if (!isLoginUrl && (statusCode === 401 || statusCode === 403)) {
        // eslint-disable-next-line no-alert
        alert(errorMessage);
        localStorage.removeItem('editor-token');
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  },
);

export default api;
